import React, { useRef, useState, useEffect } from 'react'
import useProgressStore from '../../store/progressStore'

const GlobalProgressBox = () => {
  const {
    isActive,
    isValidating,
    isSubmitting,
    isCompleted,
    uploadProgress,
    updateProgress,
    validationMessage,
    submissionMessage,
    successMessage,
    position,
    setActive,
    setPosition,
    reset
  } = useProgressStore()

  // Draggable functionality
  const progressBoxRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false)
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 })

  const handleMouseDown = (e) => {
    if (progressBoxRef.current) {
      setIsDragging(true)
      const rect = progressBoxRef.current.getBoundingClientRect()
      setDragOffset({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      })
    }
  }

  const handleMouseMove = (e) => {
    if (isDragging && progressBoxRef.current) {
      const newLeft = e.clientX - dragOffset.x
      const newTop = e.clientY - dragOffset.y
      
      // Update the position in the store
      setPosition({
        right: 'auto',
        bottom: 'auto',
        left: `${newLeft}px`,
        top: `${newTop}px`
      })
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    } else {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging])

  // Apply the position from the store
  useEffect(() => {
    if (progressBoxRef.current) {
      Object.entries(position).forEach(([key, value]) => {
        progressBoxRef.current.style[key] = value
      })
    }
  }, [position])

  // Auto-hide success message after 5 seconds
  useEffect(() => {
    let timer
    if (isCompleted) {
      timer = setTimeout(() => {
        reset()
      }, 5000)
    }
    return () => clearTimeout(timer)
  }, [isCompleted])

  if (!isActive && !isCompleted) return null

  const totalProgress = (uploadProgress + updateProgress) / 2

  return (
    <div 
      className={`loader-container flex-column ${(isActive || isCompleted) && 'active'}`} 
      ref={progressBoxRef} 
      onMouseDown={handleMouseDown}
    >
      <div className="d-flex justify-content-between align-items-center w-100 mb-2">
        <h6 className="m-0 text-dark fw-bold">
          {isCompleted ? 'Success' : 'Progress Status'}
        </h6>
        <button 
          className="btn btn-sm p-0 text-secondary" 
          onClick={() => reset()}
        >
          <i className="fi fi-rr-cross-small"></i>
        </button>
      </div>
      
      {!isCompleted && (
        <div className="loader"></div>
      )}
      
      {isCompleted ? (
        <div className="text-success mb-2 mt-2">
          <i className="fi fi-rr-check-circle me-1"></i>
          {successMessage}
        </div>
      ) : (
        <>
          <div className="upload-progress">
            <div style={{ width: `${totalProgress}%` }}></div>
          </div>
          <p className="text-dark mb-0 small">
            {isValidating 
              ? validationMessage 
              : isSubmitting 
                ? submissionMessage 
                : "Processing..."}
          </p>
        </>
      )}
    </div>
  )
}

export default GlobalProgressBox
